import { Stack, TextField, Typography } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { datePickerSx, numberFreeQuestionSx } from './_styles'
import { NumberFreeQuestionProps } from './_props'
import { ERROR_MESSAGES, validateNumber } from '../../utils/number'
import ErrorIcon from '@mui/icons-material/Error'

export default function NumberFreeQuestion({ question, initialValue, onAnswer }: NumberFreeQuestionProps) {
    const [rawValue, setRawValue] = useState<string>(initialValue ?? '')
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

    useEffect(() => {
        setRawValue(initialValue ?? '')
        setErrorMessage(undefined)
    }, [question?.id, initialValue])

    const expectedFormat = question.numberExpectedFormat === 'decimal' ? 'decimal' : 'integer'

    const min = question.numberMin
    const max = question.numberMax

    const validation = useMemo(
        () => validateNumber(rawValue, expectedFormat, min, max),
        [rawValue, expectedFormat, min, max],
    )

    useEffect(() => {
        if (!rawValue || rawValue.trim().length === 0) {
            setErrorMessage(undefined)
            return
        }
        setErrorMessage(validation.error)
    }, [rawValue, validation.error])

    const handleChange = (next: string) => {
        if (expectedFormat === 'integer' && next.includes('.')) {
            setErrorMessage(ERROR_MESSAGES.integer)
        }
        if (next.trim().length === 0) {
            setRawValue('')
            onAnswer?.('')
            return
        }
        const cleaned = next.replace(/\s/g, '').replace(/[^0-9.,+\-]/g, '')
        setRawValue(cleaned)
        onAnswer?.(cleaned)
    }

    return (
        <>
            <TextField
                fullWidth
                sx={[numberFreeQuestionSx.numberInput, errorMessage ? numberFreeQuestionSx.numberInputError : {}]}
                value={rawValue}
                placeholder="Saisir un nombre ici"
                variant="outlined"
                onChange={(e) => handleChange(e.target.value)}
                inputProps={{ inputMode: 'numeric' }}
            />
            {errorMessage && (
                <Stack sx={[datePickerSx.errorMessageContainer, { borderWidth: 2 }]}>
                    <ErrorIcon sx={datePickerSx.errorIcon} />
                    <Typography>{errorMessage}</Typography>
                </Stack>
            )}
        </>
    )
}
